import React, { useState } from 'react'
import PlayVideoBtn from './PlayVideoBtn'
import Modal from '../../shared/Modal'

export default function Video({ parentClass }) {
  const [show, setShow] = useState(false)
  return (
    <>
      <Modal setShowVideo={setShow} showVideo={show} />
      <PlayVideoBtn parentClass={parentClass} setShowVideo={setShow} />
    </>
  )
}
